import { render } from "./AddressDocuments.vue?vue&type=template&id=b3fdd56e&scoped=true"
import script from "./AddressDocuments.vue?vue&type=script&lang=js"
export * from "./AddressDocuments.vue?vue&type=script&lang=js"

import "./AddressDocuments.vue?vue&type=style&index=0&id=b3fdd56e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3fdd56e"]])

export default __exports__